export default __webpack_public_path__ + "static/media/product38.13fd866c.png";